// extracted by mini-css-extract-plugin
export default {"pagination":"Paginacion_pagination__7gHtL","active":"Paginacion_active__sVgYY","flecha":"Paginacion_flecha__xl04a"};